<template>
  <div class="total-student-container">
    <div class="total-header">
      <p>Total Students</p>
    </div>

    <div class="total-content-outer">
      <!-- <table>
        <tr>
          <td>TK</td>
          <td>50</td>
        </tr>
        <tr>
          <td>SD</td>
          <td>90</td>
        </tr>
        <tr>
          <td>SMP</td>
          <td>120</td>
        </tr>
        <tr>
          <td>SMA</td>
          <td>200</td>
        </tr>
        <tr>
          <td>Total</td>
          <td>460</td>
        </tr>
      </table> -->

      <table>
        <tr
          v-for="dept in totalStudentsDept"
          :key="dept.department_id"
        >
          <td>{{ dept.department_name }}</td>
          <td>{{ dept.total }}</td>
        </tr>

        <tr>
          <td><strong>Total</strong></td>
          <td><strong>{{ totalStudents }}</strong></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import axios from 'axios'

  export default {
    props: {
      totalStudentsDept: { type: Array, default: () => [] },
      totalStudents: { type: Object, default: () => ({}) }
    },

    setup (props, { emit }) {
      return {
      }
    }
  }
</script>

<style lang="scss">
  .total-student-container {
    .total-header {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 16px;
      background-color: #152751;

      p {
        width: 100%;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: white;
      }
    }

    .total-content-outer {
      width: 100%;
      height: calc(100% - 40px);
      padding: 0px 16px;
      overflow-y: auto;

      table {
        width: 100%;
        border-collapse: collapse;

        tr {
          border-collapse: collapse;

          td {
            border-collapse: collapse;
            padding: 4px 0;
            vertical-align: bottom;
            border-bottom: 1px solid lightgray;

            &:nth-child(1) {
              width: 100px;
              font-size: 14px;
              line-height: 20px;
              font-weight: 600;
              color: gray;
            }

            &:nth-child(2) {
              width: calc(100% - 100px);
              font-size: 24px;
              line-height: 32px;
              font-weight: 600;
              color: black;
              text-align: right;
            }
          }

          &:nth-last-child(1) {
            td {
              border-bottom: none;
            }
          }

          &:hover {
            td {
              background-color: transparent;
            }
          }
        }
      }
    }
  }
</style>
